export const cookieSessionIdKey = 'CakeCookie[session_id]';
export const cookieUserIdKey = 'CakeCookie[user_id]';
